namespace Solovis.Reports.Parameters {
  export class ParameterListControl extends Solovis.UI.BaseControl {
    public parameterSet;
    public parameters;
    public parameterHolders;
    public _paramNameToHolderMap;
    public _restrictedParameterOptions;
    public paramBlockList: JQuery;
    public nonHiddenParamCount;
    public _parameterValueChangedHandler;

    private _portalServices: Solovis.Portal.IPortalServices;

    constructor(options) {
      super(options);

      if (options.portalServices) {
        this._portalServices = options.portalServices;
      } else {
        this._portalServices = new Solovis.Portal.SitePortalServices();
      }

      this.parameterSet = Solovis.isNotNull(options.parameterSet)
        ? options.parameterSet
        : null;
      this.parameters = this.parameterSet ? this.parameterSet.parameters : null;

      this.parameterHolders = [];
      this._paramNameToHolderMap = {};

      // Set up a map of restricted options for a parameter (paramName maps to list of available options)
      this._restrictedParameterOptions = Solovis.isNotNull(
        options.restrictedParameterOptions
      )
        ? options.restrictedParameterOptions
        : {};
    }

    public doInitAsync() {
      var self = this;

      // NOTE: BaseControl::_invokeInit says this should return a promise;
      if (this.parameterSet.areAllParametersReady) {
        this.notifyInitComplete();
      } else {
        var initCompleteCallback = _.once(function () {
          self.notifyInitComplete();
        });

        $(this.parameterSet).bind("allParametersReady", function () {
          initCompleteCallback();
        });

        if (this.parameterSet.areAllParametersReady) {
          // We run this check again to make sure parameters didn't finish loading just before binding to allParametersReady event.
          initCompleteCallback();
        }
      }
    }

    public doRenderNew() {
      var self = this;

      this.paramBlockList = $("<div>")
        .addClass("paux report-param-block-list")
        .css("display", "flex")
        .css("flex-wrap", "wrap")
        .appendTo(this.container);

      // Create parameter holders
      $(this.parameters).each(function (i, paramInfo: any) {
        var paramHolder = {
          paramInfo: paramInfo,
        };

        self.parameterHolders.push(paramHolder);
        self._paramNameToHolderMap[paramInfo.name] = paramHolder;
      });

      var nonHiddenParamCount = 0;
      // visibleToggleCount is the number of parameters wtih a custom visibility handler.
      let visibleToggleCount = 0;

      // Create parameter controls.
      $(this.parameterHolders).each(async function (i, paramHolder: any) {
        const paramInfo = paramHolder.paramInfo;
        if (!paramInfo.hidden) {
          visibleToggleCount++;

          //Set up getting the parameter type
          var paramEditControlType = null;
          if (paramInfo.parameterControl) {
            paramEditControlType = paramInfo.parameterControl;
          } else if (paramInfo.parameterType) {
            paramEditControlType =
              Solovis.Reports.ParameterTypes.getParameterControlForParameterType(
                paramInfo.parameterType
              );
          } else {
            throw (
              "No parameterType or parameterControl specified for parameter: " +
              paramInfo.name
            );
          }

          if (typeof paramEditControlType == "string") {
            var paramEditControlTypeName = paramEditControlType;
            paramEditControlType = Solovis.resolveObject(
              paramEditControlTypeName
            );
            if (!paramEditControlType) {
              throw (
                "Unable to load parameter control: " + paramEditControlTypeName
              );
            }
          }

          // NOTE: param block is the label + control self.paramBlockList is all controls
          const paramBlock = $("<div>")
            .addClass("report-param-block")
            .appendTo(self.paramBlockList);
          Solovis.Site.TrackingHelper.trackElementAs(paramBlock[0], `param-${paramInfo.name}-${paramInfo.parameterType}`);
          paramHolder.paramBlockElement = paramBlock;
          if (!paramEditControlType.hasNewRender) {
            paramBlock.css("height", "100%");
          } else {
            paramBlock.css("border", "none");
            //paramBlock.css("margin-left", "10px").css("margin-top", "10px");
          }
          // Initalize the param location with the block incase it doesn't need to change
          let paramEditContainer = paramBlock;
          const id = Solovis.UX.Utils.generateId("control");
          const controlSlotId = `${id}-slot`;
          const isBool = paramInfo.parameterType === "bool";
          if (paramEditControlType.hasNewRender) {
            const childrenId = `${id}-child`;
            await Solovis.UX.Utils.placeComponent(
              "ControlLabel",
              paramBlock[0],
              {
                id,
                help: paramInfo.help,
                paramInfo: Solovis.UX.Utils.getTooltipFromParamInfo(paramInfo),
                label: !isBool ? paramInfo.label : " ",
                controlSlotId: controlSlotId,
                childrenId: childrenId,
              }
            );
            paramEditContainer = $(`#${childrenId}`);
            if (!paramInfo.list) {
              paramEditContainer.attr(
                "data-parameter-type",
                paramInfo.parameterType
              );
            }
          } else {
            // NOTE: paramLabelHeader is the holder for the parameter label
            var paramLabelHeader = $("<div>")
              .addClass("report-param-block-label-row")
              .appendTo(paramBlock);
            if (paramInfo.help) {
              var paramHelpLink = $("<a>")
                .html('<span class="fa fa-question-circle"></span>')
                .css("float", "right")
                .css("display", "inline-block")
                .css("margin-left", "8px")
                .click(function () {
                  self._showParameterHelp(paramInfo);
                })
                .appendTo(paramLabelHeader);
            }
            var paramLabelSpan = $("<span>").text(paramInfo.label);
            paramLabelHeader.append(paramLabelSpan);
            self._enableDragAndDropOfParameterLabel(paramLabelSpan, paramInfo);
            self._enableParameterContextMenu(paramLabelSpan, paramInfo);

            // NOTE: paramEditContainer is the holder for the parameter control its self
            paramEditContainer = $("<div>")
              .addClass("report-param-block-editor-row")
              .appendTo(paramBlock);

            if (!paramInfo.list) {
              paramEditContainer.addClass(
                "report-param-block-editor-row-single-item"
              );
            } else {
              paramEditContainer.addClass("report-param-block-editor-row-list");
            }
          }

          var paramEditControlHost = new Solovis.UI.ControlHost({
            container: paramEditContainer,
          });
          paramHolder.paramControlHost = paramEditControlHost;

          var initialValue = self.parameterSet.getParameterValue(
            paramInfo.name
          );

          //Setup param options
          var paramOptions: any = {
            controlHost: paramEditControlHost,
            parameterList: self,
            initialValue: initialValue,
            portalServices: self._portalServices,
            renderMode: self.options.renderMode,
          };

          if (paramInfo.settings) {
            paramOptions.settings = paramInfo.settings;
          }

          if (paramInfo.list) {
            paramOptions.parameterControlType = paramEditControlType;
            paramEditControlType =
              Solovis.Reports.Parameters.MultiValuedParameterControl;
          }

          if (!paramEditControlType) {
            throw (
              "Unable to find parameter control type: " +
              paramInfo.parameterControl
            );
          }

          // TODO: + reportOptions.renderWithNewControls into paramOptions and then use that as the "render driver"

          var paramEditControl = new paramEditControlType(
            paramOptions,
            paramInfo
          );
          // TODO: find way to move this into AssetSelectionSetParameterControls
          if (paramEditControl.slotRenderFunction) {
            const slotContainer = $(`#${controlSlotId}`);
            paramEditControl.slotRenderFunction(slotContainer);
          }

          $(paramEditControl).bind("parameterValueChanged", function () {
            try {
              var paramValue = paramEditControl.getParameterValue();
              self.parameterSet.internalSetFullParameterValue(
                paramInfo.name,
                paramValue,
                self
              );
            } catch (ex) {
              console.log(ex);
            }
          });

          paramEditControlHost.setCurrentControl(paramEditControl);
        }
      });
      // Register for change notifications on the parameter set and use it to update the UI parameter editor control.
      this._parameterValueChangedHandler = function (e, data) {
        if (data.source !== self) {
          var paramName = data.name;
          var paramValue = self.parameterSet.getParameterValue(paramName);

          // Find parameter editor and set the value.
          if (self._paramNameToHolderMap[paramName]) {
            var holder = self._paramNameToHolderMap[paramName];
            if (holder) {
              if (holder.paramControlHost) {
                self._setParameterValueOnControlHost(
                  holder.paramControlHost,
                  paramValue
                );
              } else if (holder.restrictedChoiceControl) {
                holder.restrictedChoiceControl.setParameterValue(paramValue, {
                  more: { suppressChangeNotification: true },
                });
              }
            }
          }
        }

        if (visibleToggleCount > 0) {
          self._updateVisibilityForParameters();
        }
      };

      $(this.parameterSet).bind(
        "parameterValueChanged",
        this._parameterValueChangedHandler
      );

      // Update initial visibility state.
      if (visibleToggleCount > 0) {
        self._updateVisibilityForParameters();
      }
    }

    public doRenderClassic() {
      var self = this;

      this.paramBlockList = $("<div>")
        .addClass("report-param-block-list")
        .appendTo(this.container);

      // Create parameter holders
      $(this.parameters).each(function (i, paramInfo: any) {
        var paramHolder = {
          paramInfo: paramInfo,
        };

          self.parameterHolders.push(paramHolder);
          self._paramNameToHolderMap[paramInfo.name] = paramHolder;

      });

      var nonHiddenParamCount = 0;
      // visibleToggleCount is the number of parameters wtih a custom visibility handler.
      var visibleToggleCount = 0;

      // Create parameter controls.
      $(this.parameterHolders).each(async function (i, paramHolder: any) {
        var paramInfo = paramHolder.paramInfo;
        if (!paramInfo.hidden) {
          // NOTE: param block is the label + control self.paramBlockList is all controls
          var paramBlock = $("<div>")
            .addClass("report-param-block")
            .appendTo(self.paramBlockList);
          Solovis.Site.TrackingHelper.trackElementAs(paramBlock[0], `param-${paramInfo.name}-${paramInfo.parameterType}`);
          paramHolder.paramBlockElement = paramBlock;

          if (paramInfo.visible) {
            visibleToggleCount++;
          }

          // NOTE: paramLabelHeader is the holder for the parameter label
          var paramLabelHeader = $("<div>")
            .addClass("report-param-block-label-row")
            .appendTo(paramBlock);
          if (paramInfo.help) {
            var paramHelpLink = $("<a>")
              .html('<span class="fa fa-question-circle"></span>')
              .css("float", "right")
              .css("display", "inline-block")
              .css("margin-left", "8px")
              .click(function () {
                self._showParameterHelp(paramInfo);
              })
              .appendTo(paramLabelHeader);
          }
          var paramLabelSpan = $("<span>").text(paramInfo.label);
          paramLabelHeader.append(paramLabelSpan);
          self._enableDragAndDropOfParameterLabel(paramLabelSpan, paramInfo);
          self._enableParameterContextMenu(paramLabelSpan, paramInfo);

          // NOTE: paramEditContainer is the holder for the parameter control its self
          var paramEditContainer;
          paramEditContainer = $("<div>")
            .addClass("report-param-block-editor-row")
            .appendTo(paramBlock);

          if (!paramInfo.list) {
            paramEditContainer.addClass(
              "report-param-block-editor-row-single-item"
            );
          } else {
            paramEditContainer.addClass("report-param-block-editor-row-list");
          }

          if (
            self._restrictedParameterOptions[paramInfo.name] ||
            paramInfo.allowedValues
          ) {
            // TODO: need to understand how createRestrictedParameterControl works does it build same as normal
            self._createRestrictedParameterControl(
              paramHolder,
              paramInfo,
              paramEditContainer
            );
          } else {
            var paramEditControlHost = new Solovis.UI.ControlHost({
              container: paramEditContainer,
            });
            paramHolder.paramControlHost = paramEditControlHost;

            var initialValue = self.parameterSet.getParameterValue(
              paramInfo.name
            );

            var paramEditControlType = null;
            if (paramInfo.parameterControl) {
              paramEditControlType = paramInfo.parameterControl;
            } else if (paramInfo.parameterType) {
              paramEditControlType =
                Solovis.Reports.ParameterTypes.getParameterControlForParameterType(
                  paramInfo.parameterType
                );
            } else {
              throw (
                "No parameterType or parameterControl specified for parameter: " +
                paramInfo.name
              );
            }

            if (typeof paramEditControlType == "string") {
              var paramEditControlTypeName = paramEditControlType;
              paramEditControlType = Solovis.resolveObject(
                paramEditControlTypeName
              );
              if (!paramEditControlType) {
                throw (
                  "Unable to load parameter control: " +
                  paramEditControlTypeName
                );
              }
            }

            var paramOptions: any = {
              controlHost: paramEditControlHost,
              parameterList: self,
              initialValue: initialValue,
              portalServices: self._portalServices,
            };

            if (paramInfo.settings) {
              paramOptions.settings = paramInfo.settings;
            }

            if (paramInfo.list) {
              paramOptions.parameterControlType = paramEditControlType;
              paramEditControlType =
                Solovis.Reports.Parameters.MultiValuedParameterControl;
            }

            if (!paramEditControlType) {
              throw (
                "Unable to find parameter control type: " +
                paramInfo.parameterControl
              );
            }

            //var paramEditControl = new paramEditControlType(paramOptions);
            var paramEditControl = new paramEditControlType(
              paramOptions,
              paramInfo
            );

            $(paramEditControl).bind("parameterValueChanged", function () {
              try {
                var paramValue = paramEditControl.getParameterValue();
                self.parameterSet.internalSetFullParameterValue(
                  paramInfo.name,
                  paramValue,
                  self
                );
                self._updateParamBlockTitle(paramHolder);
              } catch (ex) {
                console.log(ex);
              }
            });

            paramEditControlHost.setCurrentControl(paramEditControl);
            self._updateParamBlockTitle(paramHolder);
          }
        }
      });

      if (this.nonHiddenParamCount == 0) {
        this.paramBlockList.css("display", "none");
      }

      // Register for change notifications on the parameter set and use it to update the UI parameter editor control.
      this._parameterValueChangedHandler = function (e, data) {
        if (data.source !== self) {
          var paramName = data.name;
          var paramValue = self.parameterSet.getParameterValue(paramName);

          // Find parameter editor and set the value.
          if (self._paramNameToHolderMap[paramName]) {
            var holder = self._paramNameToHolderMap[paramName];
            if (holder) {
              if (holder.paramControlHost) {
                self._setParameterValueOnControlHost(
                  holder.paramControlHost,
                  paramValue
                );
                self._updateParamBlockTitle(holder);
              } else if (holder.restrictedChoiceControl) {
                holder.restrictedChoiceControl.setParameterValue(paramValue, {
                  more: { suppressChangeNotification: true },
                });
              }
            }
          }
        }

        if (visibleToggleCount > 0) {
          self._updateVisibilityForParameters();
        }
      };

      $(this.parameterSet).bind(
        "parameterValueChanged",
        this._parameterValueChangedHandler
      );

      // Update initial visibility state.
      if (visibleToggleCount > 0) {
        self._updateVisibilityForParameters();
      }
    }

    public doRender() {
      if (this.options.renderMode === "modern") {
        this.doRenderNew();
      } else {
        this.doRenderClassic();
      }
    }

    public _createRestrictedParameterControl(
      paramHolder,
      paramInfo,
      paramEditContainer
    ) {
      var self = this;
      var choiceSettings: any = {};

      if (this._restrictedParameterOptions[paramInfo.name]) {
        choiceSettings.options =
          this._restrictedParameterOptions[paramInfo.name];
      } else if (paramInfo.allowedValues) {
        choiceSettings.optionsAsync = function (callback) {
          Solovis.Reports.ParameterSet.preloadParameterValuesOfOneType(
            paramInfo.parameterType,
            paramInfo.allowedValues,
            function (response, success) {
              if (success) {
                // NOTE: This only supports values that have a label or name sub-property now.
                var options = [];
                $(response.result).each(function (i, value: any) {
                  // NOTE: This looks for a label first, but falls back to name if that is not present.
                  let labelToUse = value.label ? value.label : value.name;

                  options.push({ label: labelToUse, value: value });
                });
                callback({ result: options }, true);
              } else {
                callback(response, false);
              }
            },
            self._portalServices
          );
        };
      }

      self._createRestrictedParameterControlForChoiceSettings(
        paramHolder,
        paramInfo,
        paramEditContainer,
        choiceSettings
      );
    }

    public _createRestrictedParameterControlForChoiceSettings(
      paramHolder,
      paramInfo,
      paramEditContainer,
      choiceSettings
    ) {
      var self = this;
      var availableOptions = this._restrictedParameterOptions[paramInfo.name];

      var restrictedControlHost = new Solovis.UI.ControlHost({
        container: paramEditContainer,
      });
      paramHolder.restrictedControlHost = restrictedControlHost;

      var initialValue = Solovis.isNotNull(paramInfo.initialValue)
        ? paramInfo.initialValue
        : null;
      if (paramInfo.list && initialValue && initialValue.length == 1) {
        // Use first value as the value.
        initialValue = initialValue[0];
      }

      var choiceControl = new Solovis.Reports.Parameters.ChoiceParameterControl(
        {
          initialValue: initialValue,
          settings: choiceSettings,
        }
      );
      paramHolder.restrictedChoiceControl = choiceControl;

      restrictedControlHost.setCurrentControl(choiceControl);

      $(choiceControl).bind("parameterValueChanged", function () {
        try {
          var paramValue = choiceControl.getParameterValue();
          if (paramInfo.list) {
            // Wrap value in array.
            if (Solovis.isNotNull(paramValue)) {
              paramValue = [paramValue];
            } else {
              paramValue = null;
            }
          }

          self.parameterSet.setParameterValue(paramInfo.name, paramValue);
        } catch (ex) {
          console.log(ex);
        }
      });
    }

    public _setParameterValueOnControlHost(controlHost, newValue) {
      return controlHost.currentControl.setParameterValue(newValue, {
        more: { suppressChangeNotification: true },
      });
    }

    public _showParameterHelp(paramInfo) {
      Solovis.Site.HelpManager.showCustomHelpDialog(paramInfo.help, {
        title: paramInfo.label,
      });
    }

    public doDestroy() {
      if (this._parameterValueChangedHandler) {
        $(this.parameterSet).unbind(
          "parameterValueChanged",
          this._parameterValueChangedHandler
        );
        this._parameterValueChangedHandler = null;
      }
    }

    private _updateParamBlockTitle(paramHolder: any) {
      if (!paramHolder.paramBlockElement || !paramHolder.paramInfo.parameterType) {
        return;
      }
      const nameElements = $(paramHolder.paramBlockElement).find(
        '.report-param-block-editor-row > div > :is(a, span):first-child,' +
        '.multi-valued-parameter-line-item > div.control-host > div > :is(a, span):first-child'
      );
      nameElements.each(function() {
        $(this).toggleClass('has-value', !!(this as HTMLElement).innerText);
      });
      const value = this.parameterSet.getParameterValue(paramHolder.paramInfo.name);
      const controlTypeName = Solovis.Reports.ParameterTypes.getParameterControlForParameterType(
        paramHolder.paramInfo.parameterType
      );
      const control = Solovis.resolveObject(controlTypeName);
      if (!control?.getLabel) {
        return;
      }
      if (Array.isArray(value)) {
        $(paramHolder.paramBlockElement).removeAttr("title");
        nameElements.each((i, el) => {
          const itemLabel = value[i] ? control.getLabel(value[i]) : null;
          const lineItem = $(el).closest('.multi-valued-parameter-line-item');
          if (itemLabel && this._isOverflowing(el as HTMLElement)) {
            lineItem.attr("title", itemLabel);
          } else {
            lineItem.removeAttr("title");
          }
        });
      } else {
        const nameAnchor = nameElements[0] as HTMLElement;
        const label = control.getLabel(value);
        if (label && nameAnchor && this._isOverflowing(nameAnchor)) {
          $(paramHolder.paramBlockElement).attr("title", label);
        } else {
          $(paramHolder.paramBlockElement).removeAttr("title");
        }
      }
    }

    private _isOverflowing(element: HTMLElement): boolean {
      if (!element.innerText) return false;
      return element.clientWidth
        ? element.scrollWidth > element.clientWidth + 1
        : false;
    }

    public _updateVisibilityForParameters() {
      var self = this;

      $(this.parameterHolders).each(function (i, paramHolder: any) {
        var paramInfo = paramHolder.paramInfo;
        if (paramInfo.visible) {
          var isVisible = paramInfo.visible.call(self.parameterSet);
          if (isVisible) {
            $(paramHolder.paramBlockElement).css("display", "inline-block");
          } else {
            $(paramHolder.paramBlockElement).css("display", "none");
          }
        }
      });
    }

    public _enableDragAndDropOfParameterLabel(labelElement, paramInfo) {
      /// <summary>
      /// We support dragging of parameter labels to help facilitate parameter mappings on Custom Panels (possibly other controls in future).
      /// </summary>
      var self = this;

      // First, we register the drag events.
      var jElement = $(labelElement);
      jElement.attr("draggable", true as any);

      var node = jElement.get(0);

      node.ondragstart = function (e) {
        var paramRef = {
          name: paramInfo.name,
          label: paramInfo.label,
        };

        var solovisParamText = "solovis-param|" + JSON.stringify(paramRef);

        e.dataTransfer.setData("text", solovisParamText);
      };

      node.addEventListener(
        "selectstart",
        function (e) {
          // Make drag start work in IE.
          e.preventDefault();
          (this as any).dragDrop();
          return false;
        },
        false
      );

      // We also register for drop events.

      node.ondragenter = function (e) {
        // Allow drop.
        e.preventDefault();
      };

      node.ondragover = function (e) {
        // Allow drop.
        e.preventDefault();
      };

      node.ondrop = function (e) {
        e.preventDefault();
        var data = e.dataTransfer.getData("text");
        if (data && data.indexOf("solovis-param|") == 0) {
          try {
            var solovisParamJson = data.substr("solovis-param|".length);
            var droppedParamRef = JSON.parse(solovisParamJson);

            self._notifyParameterLabelOnParameterLabelDrop(
              droppedParamRef,
              paramInfo
            );
          } catch (ex) {
            console.log(
              "ERROR: processing solovis-param drop event on parameter label"
            );
            console.log(ex);
          }
        }

        return false;
      };
    }

    public _notifyParameterLabelOnParameterLabelDrop(
      droppedParamRef,
      targetParamInfo
    ) {
      $(this).trigger("parameterLabelOnParameterLabelDrop", {
        droppedParamRef: droppedParamRef,
        targetParamInfo: targetParamInfo,
      });
    }

    public _enableParameterContextMenu(element, paramInfo) {
      var self = this;

      $(element).on("contextmenu", function (e) {
        var links = [];
        links.push({
          label: "Parameter Info",
          click: function () {
            self._showParameterInfoDialog(paramInfo);
          },
        });

        Solovis.UI.PopupLinkPanel.showLinks({
          offset: { left: e.pageX, top: e.pageY },
          links: links,
        });

        e.preventDefault();
        return false;
      });
    }

    public _showParameterInfoDialog(paramInfo) {
      var formDiv = $("<div>");

      $("<div>")
        .text("Label: ")
        .append($("<span>").text(paramInfo.label))
        .appendTo(formDiv);
      $("<div>")
        .text("Name: ")
        .append($("<span>").text(paramInfo.name))
        .appendTo(formDiv);
      if (paramInfo.parameterType) {
        $("<div>")
          .text("Parameter Type: ")
          .append($("<span>").text(paramInfo.parameterType))
          .appendTo(formDiv);
      }
      if (paramInfo.list) {
        $("<div>").text("List").appendTo(formDiv);
      }

      Solovis.UI.alert(formDiv, "Parameter Info");
    }
  }
}
